import axios from "axios";
import { getAxiosConfigWithToken } from "../helpers/functions_helper"
import * as url from "../helpers/url_helper"

const SERVER_URL = process.env.REACT_APP_SERVER_URL;

class UserTypeService {
    async getUserType(DATA: any) {
        const response = await axios
            .get(SERVER_URL + url.GET_USER_TYPE + "/" + DATA.id + "/" + DATA.user_type_id,
                {
                    headers: getAxiosConfigWithToken()
                }
            ).then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error;
            });
            return response;
    }

    async getUserTypeList(DATA: any) {
        const response = await axios
            .post(SERVER_URL + url.GET_USER_TYPE_LIST, DATA,
                {
                    headers: getAxiosConfigWithToken()
                }
            ).then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error;
            });
            return response;
    }

    async createUserType(DATA: any) {
        const response = await axios
            .put(SERVER_URL + url.CREATE_USER_TYPE, DATA,
                {
                    headers: getAxiosConfigWithToken()
                }
            ).then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error;
            });
            return response;
    }

    async updateUserType(DATA: any) {
        const response = await axios
            .post(SERVER_URL + url.UPDATE_USER_TYPE, DATA,
                {
                    headers: getAxiosConfigWithToken()
                }
            ).then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error;
            });
            return response;
    }

    async deleteUserType(DATA: any) {
        const response = await axios
            .post(SERVER_URL + url.DELETE_USER_TYPE, DATA,
                {
                    headers: getAxiosConfigWithToken()
                }
            ).then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error;
            });
            return response;
    }
}

export default new UserTypeService();